export const API_URL = process.env.REACT_APP_API_URL;

export const END_POINTS = {
  // auth
  login: "/login",
  refreshToken: "/login/token",

  //users
  user: "/admin/user",
  userSearch: "/admin/user-search",
  updateUser: "/admin/update-user-status",
  resetAnonymousQuota: "/admin/reset-anonymous-quota",

  //dashboard
  dashboard: "/admin/dashboard",

  //notification
  notification: "/notification",
  notificationCount: "/notification/count",
  //posts
  comment: "/admin/comment",
  discussion: "/admin/discussion",
  updateComment: "/admin/updateComment",
  post: "/admin/post",
  addPost: "/admin/post",
  postLike: "/admin/getLike",
  updatePost: "/admin/update-post-status",
  categories: "/admin/category",
  verifyCategoryPassword: "/admin/verify-category-password",
  subscription: "/admin/subscription",
  deletePost: "/admin/delete-post",
  getReport: "/admin/report",
  getComment: "/admin/comment",
  addFcm: "/admin/fcm",
  discussionUpdate: "/admin/discussion",
  getcouponcode: "/admin/coupon_code_list",
  createCouponCode: "/admin/create_coupon_code",
  editCouponCode: "/admin/edit_coupon_code",
  news: "/admin/news",
  newsStatus: "/admin/news-status",
};
